<template>
  <el-radio-button v-bind="$attrs">
    <slot />
  </el-radio-button>
</template>

<script>
import ElRadioButton from 'vue-xpc/src/element-ui/packages/radio/src/radio-button.vue';
export default {
  name: 'RtRadioButton',
  components: { ElRadioButton }
};
</script>



// WEBPACK FOOTER //
// rtRadioButton.vue?452ce967